// @flow
import * as React from 'react';
import {BodyMono} from 'sail/Text';
import type {InputCommand} from './terminal/command';
import {Stripe} from './executables/stripe';
import {brew} from './executables/brew';
import {clear} from './executables/clear';
import {exit} from './executables/exit';
import {cd} from './executables/cd';
import {ls} from './executables/ls';
import {pwd} from './executables/pwd';
import {feedback} from './executables/feedback';
import {shortcuts} from './executables/shortcuts';
import {help} from './executables/help';

export const executables = {
  stripe: Stripe,
  brew,
  clear,
  exit,
  cd,
  ls,
  pwd,
  feedback,
  shortcuts,
  help,
};

export function execute(
  command: InputCommand,
  apiKey: string,
  setAllowInput: (boolean) => void,
) {
  if (command.executable === null || command.executable === '') {
    setAllowInput(true);
    return '';
  }

  // The command is not in the executable list above
  if (!(command.executable in executables)) {
    setAllowInput(true);
    return (
      <BodyMono color="gray200">
        command not found: {command.executable}
      </BodyMono>
    );
  }

  const executable = new executables[command.executable](
    command,
    setAllowInput,
  );

  if (command.isHelp) {
    return (
      <BodyMono color="gray200" style={{whiteSpace: 'pre-wrap'}}>
        {executable.help()}
      </BodyMono>
    );
  }

  return executable.run(apiKey);
}
